'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { FormattedReactMessage } from 'LearningCenterUI/components/I18n';
import UILink from 'UIComponents/link/UILink';
import keyMirror from 'react-utils/keyMirror';
const DEPRECATED_TRACKS = keyMirror({
  6: null,
  22: null
});

const TrackDeprecatedDescription = ({
  compressed,
  trackId,
  message,
  cta
}) => {
  let learnMoreLink;

  switch (trackId) {
    case DEPRECATED_TRACKS['6']:
      {
        learnMoreLink = 'https://designers.hubspot.com/blog/were-sunsetting-the-hubspot-design-certification-heres-why';
        break;
      }

    case DEPRECATED_TRACKS['22']:
      {
        learnMoreLink = 'https://blog.hubspot.com/customers/new-curriculum-inbound-marketing-sales-training';
        break;
      }

    default:
      learnMoreLink = '';
  }

  const noticeToDisplay = DEPRECATED_TRACKS[trackId] ? trackId : 'default';

  if (message) {
    return /*#__PURE__*/_jsxs("div", {
      children: [message, !compressed ? /*#__PURE__*/_jsx("br", {}) : ' ', cta && /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: cta,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.learnMore"
        })
      })]
    });
  }

  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `learningCenter.tracks.deprecations.noticesById.${noticeToDisplay}`,
    options: {
      learnMore: /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: learnMoreLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.learnMore"
        })
      })
    }
  });
};

TrackDeprecatedDescription.propTypes = {
  compressed: PropTypes.bool,
  cta: PropTypes.string,
  message: PropTypes.string,
  trackId: PropTypes.string.isRequired
};
export default TrackDeprecatedDescription;